import React from 'react';
import { Settings, Activity, PanelRight } from 'lucide-react';
import { StatusIndicator } from './StatusIndicator';
import { SpaceStatus } from '../types/space';
interface SpaceHeaderProps {
  name: string;
  status: SpaceStatus;
  onToggleSidebar: () => void;
  sidebarOpen: boolean;
}
export function SpaceHeader({
  name,
  status,
  onToggleSidebar,
  sidebarOpen
}: SpaceHeaderProps) {
  return <header className="h-14 border-b border-gray-200 bg-white flex items-center justify-between px-6 flex-shrink-0 z-20" data-id="element-224">
      {/* Left: Identity */}
      <div className="flex items-center space-x-4" data-id="element-225">
        <h1 className="text-sm font-semibold text-gray-900 hover:bg-gray-50 px-2 py-1 rounded cursor-pointer transition-colors" data-id="element-226">
          {name}
        </h1>
        <StatusIndicator status={status} data-id="element-227" />
      </div>

      {/* Right: Actions & Meta */}
      <div className="flex items-center space-x-3" data-id="element-228">
        {/* Avatars */}
        <div className="flex -space-x-2 mr-4" data-id="element-229">
          <div className="h-7 w-7 rounded-full bg-blue-100 border-2 border-white flex items-center justify-center text-[10px] font-bold text-blue-700" data-id="element-230">
            JD
          </div>
          <div className="h-7 w-7 rounded-full bg-pink-100 border-2 border-white flex items-center justify-center text-[10px] font-bold text-pink-700" data-id="element-231">
            SK
          </div>
          <div className="h-7 w-7 rounded-full bg-emerald-100 border-2 border-white flex items-center justify-center text-[10px] font-bold text-emerald-700" data-id="element-232">
            MC
          </div>
          <div className="h-7 w-7 rounded-full bg-amber-100 border-2 border-white flex items-center justify-center text-[10px] font-bold text-amber-700" data-id="element-233">
            LP
          </div>
          <div className="h-7 w-7 rounded-full bg-purple-100 border-2 border-white flex items-center justify-center text-[10px] font-bold text-purple-700" data-id="element-234">
            AI
          </div>
        </div>

        <div className="h-4 w-px bg-gray-200 mx-2" data-id="element-235"></div>

        {/* System Status */}
        <button onClick={onToggleSidebar} className={`flex items-center space-x-2 px-2.5 py-1.5 rounded-md text-xs font-medium transition-colors ${sidebarOpen ? 'bg-blue-50 text-blue-600' : 'text-gray-500 hover:bg-gray-50 hover:text-gray-700'}`} title="Toggle context panel" data-id="element-236">
          <Activity className="h-3.5 w-3.5" data-id="element-237" />
          <span data-id="element-238">System</span>
        </button>

        <button className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-50 rounded-md transition-colors" data-id="element-239">
          <Settings className="h-4 w-4" data-id="element-240" />
        </button>
      </div>
    </header>;
}